import { render, staticRenderFns } from "./anti-fake-result.vue?vue&type=template&id=4d08c757&scoped=true"
import script from "./anti-fake-result.vue?vue&type=script&lang=js"
export * from "./anti-fake-result.vue?vue&type=script&lang=js"
import style0 from "./anti-fake-result.vue?vue&type=style&index=0&id=4d08c757&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d08c757",
  null
  
)

export default component.exports